<script>
import AudioIcon from '@/components/util/AudioIcon.vue'
import ChevronIcon from '@/components/util/ChevronIcon.vue'

export default {
	name: 'VStickyButtons',
	components: {
		AudioIcon,
		ChevronIcon
	},
	emits: ['toggleSound']
}
</script>

<template>
	<div class="buttons">
		<div class="buttons__left">
			<div class="buttons__chevron">
				<ChevronIcon />
			</div>
			<div>
				<AudioIcon @toggleSound="$emit('toggleSound')" />
			</div>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.buttons
    &__left
        z-index: 6
        position: absolute
        bottom: 50%
        left: 1%

    &__chevron
      margin-bottom: 0.6rem

    @media screen and (max-width: 64em)
      &__left
        bottom: 9.5%
        left: 0.5%
</style>
